import { InboxMessageCriteria } from '@src/main/modules/messages/domain/message/inbox/inbox-message-criteria.interface';
import { OutboxMessageCriteria } from '@src/main/modules/messages/domain/message/outbox/outbox-message-criteria.interface';
import { format } from 'date-fns';

export function parseInboxMessageCriteria(
  criteria: InboxMessageCriteria,
): Record<string, string | number> {
  const params: Record<string, string | number> = {};

  if (criteria.page !== undefined) params.page = criteria.page;
  if (criteria.size !== undefined) params.size = criteria.size;
  if (criteria.sortField) params.sortField = criteria.sortField;
  if (criteria.sortOrder) params.sortOrder = criteria.sortOrder;
  if (criteria.sendBy) params.sendBy = criteria.sendBy;
  if (criteria.sendDateFrom) {
    params.sendDateFrom = format(new Date(criteria.sendDateFrom), 'EEE MMM dd yyyy');
  }
  if (criteria.sendDateTo) {
    params.sendDateTo = format(new Date(criteria.sendDateTo), 'EEE MMM dd yyyy');
  }
  if (criteria.subject) params.subject = criteria.subject;
  if (criteria.message) params.message = criteria.message;
  if (criteria.recipient) params.recipient = criteria.recipient;

  return params;
}

export function parseOutboxMessageCriteria(
  criteria: OutboxMessageCriteria,
): Record<string, string | number> {
  const params: Record<string, string | number> = {};
  if (criteria.page !== undefined) params.page = criteria.page;
  if (criteria.size !== undefined) params.size = criteria.size;
  if (criteria.sortField) params.sortField = criteria.sortField;
  if (criteria.sortOrder) params.sortOrder = criteria.sortOrder;
  if (criteria.sendBy) params.sendBy = criteria.sendBy;
  if (criteria.sendDateFrom) {
    params.sendDateFrom = format(new Date(criteria.sendDateFrom), 'EEE MMM dd yyyy');
  }
  if (criteria.sendDateTo) {
    params.sendDateTo = format(new Date(criteria.sendDateTo), 'EEE MMM dd yyyy');
  }
  if (criteria.subject) params.subject = criteria.subject;
  if (criteria.message) params.message = criteria.message;
  if (criteria.recipient) params.recipient = criteria.recipient;
  return params;
}

export function parseOutboxMessageCriteriaWithDistinct(
  criteria: OutboxMessageCriteria,
): Record<string, string | number | boolean> {
  const params = parseOutboxMessageCriteria(criteria);
  return { ...params, distinctRecipient: true };
}
